<template>
  <div class="mypage-one-time-pass-complete-page">
    <sub-header-section
      :pageTitle="$tc('MypagePage.MypageOneTimePass.completePage.pageTitle')"
      backLink="/mypage"
    />

    <one-time-pass-complete-pane class="mypage-one-time-pass-complete-page__content" />

    <action-buttons-section
      scrollTargetSelector=".mypage-one-time-pass-complete-page__content"
      :visible="true"
    >
      <atom-router-button to="/mypage" :linkText="$tc('common.toMypage')" colorType="secondary" />
    </action-buttons-section>

    <global-navigation-pane current="mypage" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomRouterButton from '@/components/atoms/AtomRouterButton.vue'
import OneTimePassCompletePane from '@/components/MypageOneTimePassCompletePage/OneTimePassCompletePane.vue'

/**
 * マイページ: ワンタイムパス: 登録完了ページ
 */
export default defineComponent({
  name: 'MypageOneTimePassCompletePage',
  components: {
    SubHeaderSection,
    GlobalNavigationPane,
    OneTimePassCompletePane,
    ActionButtonsSection,
    AtomRouterButton,
  },
})
</script>
